import React, { Component } from 'react';
import IconsWorldBase from './IconsWorlds/IconsWorldBase';
import IconsExports from './IconsExports/IconsExports';
import GeneralDefs from './General/GeneralDefs';
import IconsElements from './IconsElements/IconsElements';
import IconsAlerts from './IconsAlerts/IconsAlerts';
import TableBasic from './TableBasic/TableBasic';
import EntityProperties from './EntityProperties/EntityPropertiesDefs';
import ScannerIcons from './Scanner/scannerIcons';

class Icons extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    return (
      <div style={{ display: 'none' }}>
        <IconsWorldBase />
        <IconsExports />
        <GeneralDefs />
        <IconsAlerts />
        <IconsElements />
        <TableBasic />
        <EntityProperties />
        <ScannerIcons />
      </div>
    );
  }
}

export default Icons;
